export const SCANNER_RELEASES_BUCKET = "scanner-releases";
export const SCANNER_APK_OBJECT = "echojham-scanner.apk";

export const normalizeStaffRole = (value) => {
  const role = String(value || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_");
  if (role === "superadmin") return "super_admin";
  return role;
};

export const isAdminPortalRole = (value) => {
  const role = normalizeStaffRole(value);
  return role === "admin" || role === "super_admin";
};

export const canAccessStaffPortal = (value) => {
  const role = normalizeStaffRole(value);
  return role === "staff" || isAdminPortalRole(role);
};
